<template>
    <div class="view view__lms_superadmin_users_profile_edit_learninghistory">
        <lms-superadmin-users-profile-edit-learning-history ref="childcomponent"/>
    </div>
</template>

<script>
import LmsSuperadminUsersProfileEditLearningHistory from '@/components/lms/superadmin/users/profile/edit/LmsSuperadminUsersProfileEditLearningHistory'

export default {
  name: 'view-lms-superadmin-users-profile-edit-learning-history',
  components: { LmsSuperadminUsersProfileEditLearningHistory },
  computed: {
    routeUserId () {
      return this.$route.params.userId
    }
  },
  methods: {
    getUser () {
      this.$eventBus.$emit('start-loading')
      const userId = this.routeUserId
      return this.$store.dispatch('ebsUserGet', userId)
    }
  },
  created () {
    this.getUser().then(() => {
      this.$eventBus.$emit('stop-loading')
    })
  }
}
</script>
